module.exports = __webpack_public_path__ + "static/media/detail-empretec-mobile.471876ce.png";